import { normalizeLabel, parseNumeric } from '../../../shared/utils';

type OptionLike = { label?: string | null; value?: string | number | null };

const AUG_LABEL = 'aug';

export function isAugsburgByWerkValue(
  werkValue: unknown,
  werkOptions: OptionLike[] | undefined,
): boolean {
  const normalizedRaw = normalizeLabel(String(werkValue ?? ''));
  if (normalizedRaw === AUG_LABEL) {
    return true;
  }

  const parsedWerkValue = parseNumeric(werkValue);
  if (parsedWerkValue == null || !Array.isArray(werkOptions) || !werkOptions.length) {
    return false;
  }

  return werkOptions.some(
    (option) =>
      normalizeLabel(option?.label ?? '') === AUG_LABEL &&
      parseNumeric(option?.value) === parsedWerkValue,
  );
}